import { mainRoute } from '@pages/main-page'
import { createRoute } from '@tanstack/react-router'
import { PaymentFailedPageError } from './payment-failed-page.error'

export const paymentFailedRoute = createRoute({
  getParentRoute: () => mainRoute,
  loader: () => null,
  errorComponent: PaymentFailedPageError,
  path: '/payment/failed'
}).lazy(async () => {
  const d = await import('./payment-failed-page.lazy')
  return d.Route
})
